import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import { LEAD_SOURCE_LABELS } from "@/types/enums";
import type { Lead } from "@/types/lead";
import { formatDate } from "@/utils/format";

export function LeadCard({ lead, onOpen }: { lead: Lead; onOpen: () => void }) {
  return (
    <Paper variant="outlined" sx={{ p: 1.5, mb: 1.5, cursor: "pointer" }} onClick={onOpen}>
      <Stack spacing={0.5}>
        <Typography variant="body2" fontWeight={600}>
          {lead.fullName}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {lead.phone} {lead.age ? `· ${lead.age} лет` : ""}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {lead.subjectName ?? lead.subjectId}
        </Typography>
        <Stack direction="row" spacing={0.5} flexWrap="wrap">
          <Chip size="small" label={LEAD_SOURCE_LABELS[lead.source]} variant="outlined" />
          {lead.overdue && <Chip size="small" color="error" label="Просрочен контакт" />}
        </Stack>
        {lead.nextContactDate && (
          <Typography variant="caption" color="text.secondary">
            Следующий контакт: {formatDate(lead.nextContactDate)}
          </Typography>
        )}
        {lead.trialDate && (
          <Typography variant="caption" color="text.secondary">
            Пробный урок: {formatDate(lead.trialDate)} {lead.trialTime ?? ""}
          </Typography>
        )}
        {lead.stage === "LOST" && lead.lostReason && (
          <Typography variant="caption" color="error.main">
            Причина отказа: {lead.lostReason}
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
